export default __webpack_public_path__ + "8295c8d136364b8ddea4b928ddc146cb.ogg";